import { cx } from '@emotion/css';
import { Translate } from '@/components';
import styles from './Chip.styles';

interface ChipProps {
  children: React.ReactNode;
  variant?: string;
  dataTestId?: string;
}

export const Chip: React.FC<ChipProps> = ({
  children,
  dataTestId,
  variant = 'default',
}) => (
  <span
    className={cx(styles.chip, styles.variants[variant])}
    data-testid={dataTestId}
  >
    <Translate>{children}</Translate>
  </span>
);
